import React from 'react';
import { Box, Paper, Typography, Chip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

export const RulesInfoBox: React.FC = () => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 3,
        backgroundColor: '#e3f2fd',
        border: '1px solid #90caf9',
      }}
    >
      <Box display="flex" alignItems="flex-start" gap={1} mb={1}>
        <InfoIcon color="primary" fontSize="small" sx={{ mt: 0.3 }} />
        <Box>
          <Typography variant="subtitle2" fontWeight={600} color="primary" gutterBottom>
            Como funciona o sistema de regras
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph sx={{ mb: 1 }}>
            <strong>Dentro de cada grupo:</strong> Basta cumprir <Chip label="QUALQUER UMA" size="small" color="success" sx={{ mx: 0.5, fontWeight: 700 }} /> das regras conectadas por <Chip label="OU" size="small" color="success" sx={{ mx: 0.5, fontWeight: 700 }} />
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph sx={{ mb: 1 }}>
            <strong>Entre grupos (colunas):</strong> O cliente precisa atender <Chip label="TODOS" size="small" color="primary" sx={{ mx: 0.5, fontWeight: 700 }} /> os grupos conectados por <Chip label="E TAMBÉM" size="small" color="primary" sx={{ mx: 0.5, fontWeight: 700 }} />
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', fontSize: '0.85rem' }}>
            <strong>Exemplo:</strong> (Abastecer 30L de gasolina <strong>OU</strong> 40L de diesel) <strong>E TAMBÉM</strong> (Pagar com Pix <strong>OU</strong> ser Clube Certo)
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default RulesInfoBox;
